import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesMedicalRecords } from "reduxx/actions/pages/user/medicalRecords";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { useEffect } from 'react';
import { EDIT_MEDICAL_RECORDS_2 } from 'apis';
import apiRequest from 'utils/apiRequest';

const EditMedicalRecord2 = () => {

    const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { hasSpecialMedication, medicationName } = useSelector(state => state.medicalRecords);

    useEffect(() => {
        dispatch(handleChangeDataPagesMedicalRecords('hasSpecialMedication', profile.medicalRecords.hasSpecialMedication));
        dispatch(handleChangeDataPagesMedicalRecords('medicationName', profile.medicalRecords.medicationName));
    }, [EditMedicalRecord2]);

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        if(name === 'hasSpecialMedication')
        	dispatch(handleChangeDataPagesMedicalRecords(name, value === '1'));
        else
        	dispatch(handleChangeDataPagesMedicalRecords(name, value));
    };

    const handleSubmitForm = () => {
    	if(hasSpecialMedication === null)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'استفاده داروی روزانه را مشخص کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else if(hasSpecialMedication && (medicationName === null || medicationName.trim().length === 0) )
			dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام دارو یا داروهایی که استفاده میکنید را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else {
			apiRequest({
                dispatch,
                endpoint: EDIT_MEDICAL_RECORDS_2,
                method: 'post',
                data: { hasSpecialMedication: (hasSpecialMedication ? 1 : 0), medicationName },
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                	let newProfile = profile;
                	newProfile.medicalRecords.hasSpecialMedication = hasSpecialMedication;
                	newProfile.medicalRecords.medicationName = medicationName;
                	dispatch(handleChangeProfileData(newProfile));

                    navigate(`/medical-record3`);
                }
            });
		}
    };		

    return (
        
        <div className={sharedStyles.container}>

        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={formStyles.title}>آیا داروی خاصی بصورت روزانه استفاده می‌کنید؟</div>
				<div className={formStyles.radioGroup}>
					<label className={formStyles.radioLabel}><input type="radio" name="hasSpecialMedication" value={0} onChange={handelChangeInputs} checked={hasSpecialMedication === false} /> خیر</label>
					<label className={formStyles.radioLabel}><input type="radio" name="hasSpecialMedication" value={1} onChange={handelChangeInputs} checked={hasSpecialMedication === true} /> بله</label>
				</div>
                { hasSpecialMedication &&
                    <>
    				<div className={formStyles.title}>لطفا نام داروهایی که بصورت روزانه استفاده میکنید را ذکر کنید</div>
                    <textarea name="medicationName" value={medicationName} onChange={handelChangeInputs} className={formStyles.descriptionBox} placeholder="نام دارو" />
                    </>
                }
				<button onClick={handleSubmitForm} className={formStyles.button}>تایید</button>
        	</div>

		</div>

    );
}

export default EditMedicalRecord2;